import { render, staticRenderFns } from "./BusinessCooperation.vue?vue&type=template&id=5977cb70&scoped=true&"
import script from "./BusinessCooperation.vue?vue&type=script&lang=js&"
export * from "./BusinessCooperation.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCooperation.vue?vue&type=style&index=0&id=5977cb70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5977cb70",
  null
  
)

export default component.exports